/**
 * CR310: S0 Scan Settings v2 - Action Bar
 * Top-right action bar with Reset and Save buttons (Deal Cards pattern)
 */

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { RotateCcw, Save, Loader2 } from 'lucide-react';

interface S0ActionBarProps {
  isDirty: boolean;
  isSaving: boolean;
  onReset: () => void;
  onSave: () => void;
  disabled?: boolean;
}

export function S0ActionBar({
  isDirty,
  isSaving,
  onReset,
  onSave,
  disabled = false,
}: S0ActionBarProps) {
  return (
    <div className="flex items-center justify-end gap-2">
      {isDirty && (
        <Badge variant="secondary" className="text-xs">
          Unsaved changes
        </Badge>
      )}

      <Button
        variant="outline"
        size="sm"
        onClick={(e) => { e.stopPropagation(); onReset(); }}
        disabled={disabled || isSaving || !isDirty}
        className="h-8 text-xs px-2"
      >
        <RotateCcw className="h-3 w-3 mr-1.5" />
        Reset
      </Button>

      <Button
        size="sm"
        onClick={(e) => { e.stopPropagation(); onSave(); }}
        disabled={disabled || isSaving || !isDirty}
        className="h-8 text-xs px-2 min-w-[70px]"
      >
        {isSaving ? (
          <>
            <Loader2 className="h-3 w-3 mr-1.5 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save className="h-3 w-3 mr-1.5" />
            Save
          </>
        )}
      </Button>
    </div>
  );
}
